import Lottie from 'lottie-react'
import starAnimation from '../../assets/animations/star.json'

interface StarIconProps {
  className?: string
  size?: number
}

const StarIcon = ({ className = "w-14 h-14", size }: StarIconProps) => {
  return (
    <div className={className} style={{ aspectRatio: '1 / 1', contain: 'layout' }}>
      <div className="dark:invert dark:brightness-0 dark:contrast-200 w-full h-full">
        <Lottie
          animationData={starAnimation}
          loop={true}
          autoplay={true}
          style={{ width: size || '100%', height: size || '100%' }}
          rendererSettings={{
            preserveAspectRatio: 'xMidYMid meet'
          }}
        />
      </div>
    </div>
  )
}

export default StarIcon